import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BuildIcon from '@mui/icons-material/Build';

import { useStyles } from './useStyles';

const MaintenancePage: React.FC = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <div className={classes.iconCircle}>
                <BuildIcon className={classes.icon} />
            </div>
            <Typography className={classes.title}>System Under Construction</Typography>
            <Typography className={classes.subtitle}>
                {"We're working on improvements to make your experience better. Please check back soon."}
            </Typography>
        </Box>
    );
};

export default MaintenancePage;
